import productDisplayLandscapeImg from "../../../assets/img/product-gg-6-display-landscape.png";
import productDisplayLandscapeImgWebp from "../../../assets/img/product-gg-6-display-landscape.webp";

const Breakthrough = () => (
    <section id="breakthrough" className="gg-bg-solid-green-light">
        <div className="container-fluid">
            <div className="row justify-content-center align-content-center py-5">
                <div className="col-xxl-8 col-lg-10 col-11 py-5 px-xxl-4 px-3 gg-bg-solid-blue gg-border-radius">
                    <div className="row justify-content-center">
                        <div className="col-xxl-4 col-lg-5 col-md-5 col-12 align-content-center text-center">
                            <picture>
                                <source srcSet={productDisplayLandscapeImgWebp} type="image/webp" />
                                <img className="img-fluid gg-border-radius" src={productDisplayLandscapeImg} loading="lazy" />
                            </picture>
                        </div>
                        <div className="col-md-6 col-12 mt-lg-0 mt-3 pe-md-0 text-white text-md-start text-center align-content-center">
                            <h3 className="fw-bold mb-5">The real breakthroughs show up between Month 4 and Month 5.</h3>
                            <p className="mb-3">That’s when...</p>
                            <p className="my-3">
                                ✅  Blood sugar finally stabilises<br />
                                ✅  Energy returns, morning to night<br />
                                ✅  Cravings start to disappear<br />
                                ✅  You feel in charge of your body again<br />
                            </p>
                            <p className="fw-bold my-4">The biggest mistake we see is that people run out too soon…</p>
                            <p className="gg-yellow">
                                They don’t get to the finish line.<br />
                                They lose momentum.<br />
                                They feel like it "didn’t work"... when they were <b>so close</b> to their breakthrough.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default Breakthrough;